import React from 'react';
import { useForm } from 'react-hook-form';
import ButtonPrimary from '../../../Components/subcomponents/ButtonPrimary';
import TextInput from '../../../Components/subcomponents/Textinput';
import PhoneInput from '../../../Components/subcomponents/Phoneinput';

function Judgesignin({ onSignIn }) {
  const { register, handleSubmit, formState: { errors, isValid } } = useForm({
    mode: 'onChange', // Validates the form on every change
  });

  // Handle form submission
  const onSubmit = (data, e) => {
 // Prevents default form behavior
    onSignIn(data);
  }

  // Handle form errors
  const onError = (errors) => {
    console.log(errors); // Log any errors for debugging
  };

  return (
    <div className='max-w-xl mx-auto px-8'>
      <div className="text-4xl font-bold text-center pb-24 pt-8">Judges Login</div>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <TextInput
          label="Last name"
          name="Lastname"
          {...register('Lastname', { required: 'Last name is required' })}
          error={errors.Lastname?.message}
        />
        <PhoneInput
          label="Phone"
          name="phone"
          {...register('phone', { 
            required: 'Phone number is required'//, 
            // pattern: {
            //   value: /^[0-9]{10,}$/, // Regex to allow only numbers and minimum of 10 digits
            //   message: 'Invalid phone number'
            // }
          })}
          error={errors.phone?.message}
        />
        <div className="py-12 flex justify-center">
          <ButtonPrimary type="submit">Log In</ButtonPrimary>
        </div>
      </form>
    </div>
  );
}

export default Judgesignin;
